import { render, staticRenderFns } from "./examenesAlumno.vue?vue&type=template&id=043579d3&"
import script from "./examenesAlumno.vue?vue&type=script&lang=js&"
export * from "./examenesAlumno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports